import { render, staticRenderFns } from "./FindOpportunity.vue?vue&type=template&id=09f6c79e&"
import script from "./FindOpportunity.vue?vue&type=script&lang=js&"
export * from "./FindOpportunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports